import React, {useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import "../../resources/css/application.css";
import FormHelperText from "@material-ui/core/FormHelperText";
import {
  oibFieldHandleError,
  oibFieldHandleKeyboardKeyAction,
  oibFieldHandlePasteAction,
  validateOib
} from "../../util/ValidationUtil";
import ErrorAlert from "../alert/ErrorAlert";
import {Context} from "../../App";
import {AXIOS_BASE_BACKEND, ENV} from "../../util/Util";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Recaptcha from "./Recaptcha";
import CookieDialog from "../popup/CookieDialog";

const HomePage = () => {

  const oibRef = useRef();
  const reCaptchaRef = useRef();
  const history = useHistory();
  const {uploadData} = useContext(Context);
  const [uploadDataState, setUploadDataState] = uploadData;
  const [message, setMessage] = useState("");
  const [reCaptchaResponse, setReCaptchaResponse] = useState(null);
  const [openError, setOpenError] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [showCookieDialog, setShowCookieDialog] = useState(true);

  useLayoutEffect(() => {
    history.go(1);
  }, [history]);

  useEffect(() => {
    const postData = async () => {
      await AXIOS_BASE_BACKEND.post("checkOibAndRecaptcha", {
        oib: uploadDataState.oib,
        recaptchaResponse: reCaptchaResponse
      }).then(value => {
        setUploadDataState(prev => ({
          ...prev, uploadId: value.data.uploadId, token: value.data.token, mail: value.data.mail, uploadHash: value.data.uploadHash
        }));
        history.push(ENV.REACT_APP_DOCUMENT_UPLOAD_PAGE);
      }).catch(reason => {
        if (reason.response && reason.response.data.message === "Content not found!") {
          setMessage("Vaš OIB nije pronađen");
        } else {
          setMessage("Zahtjev nije obrađen! Molimo, pokušajte ponovo ili kontaktirajte banku u slučaju ponovnog neuspjeha.");
        }
        setSubmitButtonDisabled(false);
        setOpenError(true);
      });
    };
    if (reCaptchaResponse) {
      postData();
      reCaptchaRef.current.reset();
    }
    setReCaptchaResponse(null);
  }, [reCaptchaResponse, uploadDataState.oib, setUploadDataState, history]);

  const changeUploadState = (name, value) => {
    setUploadDataState({...uploadDataState, [name]: value});
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitFlag(true);
    if (validateOib(uploadDataState.oib)) {
      setSubmitButtonDisabled(true);
      setOpenError(false);
      reCaptchaRef.current.execute();
    } else {
      oibRef.current.focus();
    }
  };

  const onCloseCookieDialog = () => {
    setShowCookieDialog(false);
  };

  return (
    <div className="site">

      <Header/>

      <main className="site-content">

        <div className="container">

          <div className="card card--pullup card--content-center">
            <div className="w-md-75">

              <h1 className="headline-1 mb-5">Dokumenti</h1>
              <p>Kako bi ažurirali tvoj studentski status, trebaš slijediti ove korake:</p>
              <ul className="bulletlist mb-3">
                <li className="bulletlist__item">Skeniraj ili fotografiraj <strong>potvrdu o upisu nove akademske godine</strong></li>
                <li className="bulletlist__item">Nakon unosa OIB-a preusmjerit ćemo te na unos pojedinačnih datoteka* (do max. 2 stranice)</li>
                <li className="bulletlist__item">Unesi e-mail kako bismo ti poslali obavijest o zaprimljenim dokumentima</li>
                <li className="bulletlist__item"><strong>Pošalji dokumente i tvoj studentski status bit će uspješno ažuriran</strong></li>
              </ul>

              <p>Pojedinačne datoteke za slanje ne smiju biti veće od 5 MB te moraju biti u JPEG formatu.</p>

            </div>
          </div>


          <div className="card card--content-center">
            <div className="w-md-75">

              <h1 className="headline-1 mb-5">Slanje dokumenata</h1>

              <form>
                <div className="row mb-5">
                  <label htmlFor="oib" className="col-sm-3 col-md-2 col-form-label">Vaš OIB</label>
                  <div className="col-sm-6 col-md-5">
                    <input
                      className={oibFieldHandleError(submitFlag, uploadDataState.oib) ? "form-control has-error" : "form-control"}
                      type="number"
                      name={"oib"}
                      ref={oibRef}
                      onKeyDown={(e) => oibFieldHandleKeyboardKeyAction(e)}
                      onPaste={(e => oibFieldHandlePasteAction(e))}
                      value={uploadDataState.oib}
                      onChange={(e) => e.target.value.length > 11 ? uploadDataState.oib : changeUploadState(e.target.name, e.target.value)}
                    />

                    <div className="error-text">
                      <FormHelperText error={oibFieldHandleError(submitFlag, uploadDataState.oib)}>
                        {oibFieldHandleError(submitFlag, uploadDataState.oib) ? "Upisani OIB nije ispravan" : null}
                      </FormHelperText>
                    </div>

                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-sm-4 offset-sm-3 offset-md-2">
                    <Recaptcha reCaptchaRef={reCaptchaRef} setReCaptchaResponse={setReCaptchaResponse}/>
                  </div>
                </div>

                {openError && <ErrorAlert message={message}/>}

                <div className="row mb-5">
                  <div className="col-sm-4 offset-sm-3 offset-md-2">
                    <button type="submit" className="btn btn--primary" disabled={submitButtonDisabled}
                            onClick={submit}>Nastavi
                    </button>
                  </div>
                </div>
              </form>

            </div>
          </div>

        </div>
      </main>

      <Footer/>

      {showCookieDialog && <CookieDialog onClose={onCloseCookieDialog}/>}

    </div>
  );
};

export default HomePage;
